import React, { useState, useRef } from 'react'
import moment from 'moment'
import { message } from 'antd'
import request from 'meinian-package/src/utils/request'
import qs from 'qs'
import Table from 'component/table'
import EditSample from 'component/editSample'
import { isPermissions, sampleHasAuth } from 'meinian-package/src/utils/auth'
import './index.less'
import SampleDetail from 'view/detail/sampleDetail'
import { sampleSourceData, sampleTypeData } from 'component/filter/sampleFilterOptions'
import { getSampleStatusLabel } from 'component/waterfall.card/sampleCardExamine/common'
import moreFolderModalFun from '../../../../../component/useFunModal/moveFolder'

const sortRule = {
  id: [{ sort: 'ascend', value: -1 }, { sort: 'descend', value: 1 }],
  price: [{ sort: 'ascend', value: -4 }, { sort: 'descend', value: 4 }],
  updatedAt: [{ sort: 'ascend', value: -2 }, { sort: 'descend', value: 2 }],
  createdAt: [{ sort: 'ascend', value: -3 }, { sort: 'descend', value: 3 }]
}

const COLUMNS = (toDetail, teamInfo, accountInfo, onChange) => [
  { title: '样衣', dataIndex: '', key: 'sample', width: 300, render: data => <Sample data={data} toDetail={toDetail} /> },
  { title: '样衣ID', dataIndex: 'sampleCode', key: 'sampleCode', width: 150 },
  { title: '价格', dataIndex: 'price', key: 'price', sorter: true, width: 108 },
  // { title: '面料辅料', dataIndex: '', key: 'fabric', width: 96, render: data => <Fabric data={data} /> },
  // { title: '风格季节', dataIndex: '', key: 'season', width: 88, render: data => <Season data={data} /> },
  { title: '样衣状态',
    dataIndex: '',
    key: 'state',
    width: 108,
    render: data => <span>{getSampleStatusLabel({
      process: data.process,
      processId: data.processId,
      stepStatus: data.stepStatus,
      stepId: data.stepId,
      state: data.state
    })}</span> },
  { title: '样衣来源', dataIndex: '', key: 'source', width: 108, render: data => <span>{data.source ? sampleSourceData.find(m => data.source == m.value).label : ''}</span> },
  { title: '样衣类型', dataIndex: '', key: 'type', width: 108, render: data => <span>{data.type ? sampleTypeData.find(m => data.type == m.value).label : ''}</span> },
  { title: '更新时间', dataIndex: '', key: 'updatedAt', sorter: true, width: 176, render: data => <Time date={data.updatedAt} name={data.updatedUser} /> },
  { title: '创建时间', dataIndex: '', key: 'createdAt', sorter: true, width: 176, render: data => <Time date={data.createdAt} name={data.createdUser} /> },
  { title: '操作', dataIndex: '', fixed: 'right', key: 'operations', width: 200, render: data => <Operations data={data} teamInfo={teamInfo} accountInfo={accountInfo} onChange={onChange} /> },
]

export default (props) => {
  const [sortValue, setSortValue] = useState({})
  const { setParams, teamInfo, accountInfo, isBatch, setIsBatch, onChange, ...otherParams } = props
  const [visible, setVisible] = useState(false)
  const onSort = (e) => {
    setSortValue(e)
    setParams(pre => ({ ...pre, rankStatus: e.sort ? sortRule[e.key].find(m => e.sort == m.sort).value : '' }))
  }
  const toDetail = (itemData) => {
    history.replaceState({}, '', `/meinian/detail/sample/image?sampleCode=${itemData.sampleCode}`)
    setVisible(true)
  }
  return <div>
    {visible ? <SampleDetail
      visible={visible}
      onVisibleChange={_visible => setVisible(_visible)}
    /> : null}
    <Table
      className="meinian-sample-table"
      {...otherParams}
      isBatch={isBatch}
      onSort={onSort}
      onSelectBatch={() => setIsBatch(true)}
      sortValue={sortValue}
      columns={COLUMNS(toDetail, teamInfo, accountInfo, onChange)}
      keyValue="id"
    />
  </div>
}
const Sample = (props) => {
  const { data, toDetail } = props
  return <div className="sample" onClick={() => toDetail(data)}>
    <span className="sample-img" style={{ backgroundImage: `url(${data.mainImgUrl})` }} />
    <div className="sample-info">
      <span className="sample-info-title">{data.name}</span>
      <span className="sample-info-designer" title={data.designerNameList?.length > 0 ? data.designerNameList.join('、') : ''}>{data.designerNameList?.length > 0 ? data.designerNameList.join('、') : ''}</span>
      <span>{data.gender}{data.category ? '-' : ''}{data.category}</span>
    </div>
  </div>
}

const Time = (props) => {
  const { date, name } = props
  return <div className="time">
    <span>{moment(date).format('YYYY/MM/DD HH:mm:ss')}</span>
    <span style={{ color: '#999' }}>{name}</span>
  </div>
}

const Operations = (props) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const { data, accountInfo, teamInfo, onChange } = props
  const [visible, setVisible] = useState(false)
  const sampleFolderIdRef = useRef(data.sampleFolderId)

  const onMove = async (_curData, _id) => {
    const result = await request.post('/zhikuan/mn/sample/folder/move-sample-clothing', { toFolderId: _id, sampleIdList: [data.id] })
    if (result) {
      message.success('移动成功')
      if (location.pathname.startsWith('/meinian/home/sample')) {
        if (!_curData?.value) {
          return true
        }
        if (_curData?.value !== -1 && !query.parentId && !props?.containSubFolder) { // 根目录下的样衣 不显示文件夹内容 移动到子文件夹
          onChange?.()
          return true
        }
        if (query.parentId && !query.chidId) { // 父文件下的移动文件夹
          if (+query.parentId !== _id && !props?.containSubFolder) { // 当前文件夹下的子文件夹
            onChange?.()
            return true
          }

          if ((+query.parentId !== _curData?.parentId && +query.parentId !== _curData?.id) && props?.containSubFolder) { // 不是当前的父文件夹 或者 是移动到子文件夹
            onChange?.()
            return true
          }
        }
        if (query.childId && +query.childId !== _id) { // 父文件下的子文件下的样衣
          onChange?.()
          return true
        }
      }
      sampleFolderIdRef.current = result?.id
    }
  }

  return <div className="operations">
    {
      isPermissions(data.sampleClothingAuth, ['operateAndUpdateSample']) && <span onClick={() => { setVisible(true) }}>编辑</span>
    }
    {
       isPermissions(data.sampleClothingAuth, ['moveAndDeleteSample']) && <span onClick={() => {
         moreFolderModalFun?.({
           title: '移动样衣至',
           type: 'sample',
           createFolderAuth: sampleHasAuth('createAndUpdateFolder'),
           option: {
             id: sampleFolderIdRef.current
           },
           onOk: (curData, val) => onMove(curData, val)
         })
       }}
       >移动</span>
    }
    {
      data.haveBlogInfo && <span onClick={() => { window.open(`/meinian/detail/image?imageGroupEntityId=${data.blogId}&inspirationId=${data.inspirationId}&collectId=${data.collectId}`) }}>相关款式</span>
    }
    {visible ? <EditSample
      visible={visible}
      isHome
      data={data}
      setVisible={setVisible}
      accountInfo={accountInfo}
      teamInfo={teamInfo}
      {...props}
    /> : null}
  </div>
}
